import * as THREE from 'three';

const CreateCube = function () {
  let geometry = new THREE.BoxGeometry(10, 10);
  let material = new THREE.MeshNormalMaterial();
  return new THREE.Mesh( geometry, material );
};

export { CreateCube};